"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTableToken = exports.createTableDummyNode = exports.createEmptyTableCellNode = exports.createEmptyTableRepeatingRowNode = exports.createEmptyTableRowNode = exports.table = void 0;
var Text_1 = require("./Text");
var BasicBlocks_1 = require("./BasicBlocks");
var Common_1 = require("ContentTokens/Models/Common");
var createTableDummyNode = function () {
    return {
        isVoid: true,
        type: Common_1.BlockType.TableDummy,
        children: [Text_1.text.createSlateJson("")],
    };
};
exports.createTableDummyNode = createTableDummyNode;
var createEmptyTableCellNode = function () {
    return {
        isVoid: false,
        type: Common_1.BlockType.TableCell,
        children: [BasicBlocks_1.paragraph.createSlateJson([Text_1.text.createSlateJson("")])],
    };
};
exports.createEmptyTableCellNode = createEmptyTableCellNode;
var createEmptyTableRowNode = function () {
    return {
        isVoid: false,
        type: Common_1.BlockType.TableRow,
        children: [],
    };
};
exports.createEmptyTableRowNode = createEmptyTableRowNode;
var createEmptyTableRepeatingRowNode = function (repeatingToken) {
    var node = {
        isVoid: false,
        type: Common_1.BlockType.TableRepeatingRow,
        data: {},
        children: [],
    };
    if (repeatingToken) {
        node.data.repeatingToken = repeatingToken;
    }
    return node;
};
exports.createEmptyTableRepeatingRowNode = createEmptyTableRepeatingRowNode;
var table = {
    createToken: function (rows, columns, cells, columnBorders, repeatingRows) {
        if (!columnBorders) {
            var colWidth = 100 / columns;
            columnBorders = [];
            for (var i = 0; i <= columns; i++) {
                columnBorders.push(colWidth * i);
            }
        }
        if (repeatingRows) {
            return {
                type: "block",
                subType: "table",
                rows: rows,
                columns: columns,
                cells: cells,
                repeatingRows: repeatingRows,
                columnBorders: columnBorders,
                selection: null,
            };
        }
        else {
            return {
                type: "block",
                subType: "table",
                rows: rows,
                columns: columns,
                cells: cells,
                columnBorders: columnBorders,
                selection: null,
            };
        }
    },
    createSlateJson: function (rows, columns) {
        var tableJson = {
            isVoid: false,
            type: Common_1.BlockType.Table,
            data: {
                rows: rows,
                columns: columns,
                columnBorders: [],
                selection: undefined,
            },
            children: [createTableDummyNode()],
        };
        var colWidth = 100 / columns;
        for (var i = 0; i <= columns; i++) {
            tableJson.data.columnBorders.push(colWidth * i);
        }
        for (var row = 0; row < rows; row++) {
            var row_1 = createEmptyTableRowNode();
            for (var column = 0; column < columns; column++) {
                var cell = createEmptyTableCellNode();
                row_1.children.push(cell);
            }
            tableJson.children.push(row_1);
        }
        return tableJson;
    },
};
exports.table = table;
var isTableToken = function (token) {
    return token.type === "block" && token.subType === "table";
};
exports.isTableToken = isTableToken;
